import * as React from 'react';

import PolicyBeneficiaryContainer from './PolicyBeneficiaryContainer';
import { Page, PageContent, PageHeader } from '../components/common';

interface Props {
	history: any;
	match: any;
}
class PolicyBeneficiaryPage extends React.Component<Props> {
	render() {
		const title = this.props.match.params.beneficiaryId === 'new' ? 'Add a beneficiary' : 'Update beneficiary';
		return (
			<Page title={title}>
				<PageContent>
					<PageHeader title={title} className="page-header-sm" />
					<PolicyBeneficiaryContainer {...this.props} />
				</PageContent>
			</Page>
		);
	}
}
export default PolicyBeneficiaryPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/policy/PolicyBeneficiaryPage.tsx